import useRequest from '@/websdk/utils/request';

export default (function () {
  // console.error('GET==>', isContinue)
  const { isRequestSuccessed, data, exec } = useRequest({
    url: `/api/maintain/group`,
    name: 'MAINTAIN_GROUP_Get',
    method: 'GET',
  });
  //console.error('GET==>', JSON.stringify(data));
  return [isRequestSuccessed, data || [], exec];
  // }
});
